const Subtitle = () => {
  return (
    <span>
      Lead Recipients redirect leads from lead capture forms to other Orgs.
      {/* <HelpLink href="https://support.opensolar.com/hc/en-us/articles/tbc" /> */}
    </span>
  )
}

const LeadRecipientTitle = ({ record, translate, style }) => {
  return (
    <span style={style}>
      {translate('Lead Recipient')}: {record ? `"${record.title}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./LeadRecipients'), component: 'LeadRecipientList' },
  create: { lazy: () => import('./LeadRecipients'), component: 'LeadRecipientCreate' },
  edit: { lazy: () => import('./LeadRecipients'), component: 'LeadRecipientEdit' },
  options: {
    create: {
      title: 'Create Lead Recipient',
      subtitle: null,
      breadCrumb: 'Create Lead Recipient',
    },
    list: {
      title: 'Lead Recipients',
      subtitle: <Subtitle />,
      breadCrumb: 'Lead Recipients',
    },
    edit: {
      title: <LeadRecipientTitle />,
      subtitle: null,
      breadCrumb: 'Edit Lead Recipient',
    },
  },
}
